export default __webpack_public_path__ + "static/media/HistoricPriority.8c40a9be.svg";